import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from 'src/app/_base/base.component';
import { FileUpload, SocialLearningPost, PostGetResult, PostAttachments, StudentsLookups } from 'src/app/_models';
import { SocialLearningService, UserService } from 'src/app/_services';
import { EmojiEvent } from '@ctrl/ngx-emoji-mart/ngx-emoji/public_api';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FileStatuses } from 'src/app/_enums/file-statuses.enum';
import { CommunicationsPostTypes } from 'src/app/_enums';
import { UserBasicInformation } from 'src/app/_models/users/user-basic-information';

@Component({
  selector: 'app-post-edit',
  templateUrl: './post-edit.component.html',
  styleUrls: ['./post-edit.component.scss']
})
export class PostEditComponent extends BaseComponent implements OnInit {
  @Input()
  post: PostGetResult = null;
  @Output()
  saving: EventEmitter<PostGetResult> = new EventEmitter<PostGetResult>();
  postComment: string = null;
  attachments: PostAttachments[] = [];
  files: FileUpload[] = [];
  isOpenedEmoji: boolean = false;
  sharingMode: number = 0;
  isUploaderOpened: boolean = false;
  students: StudentsLookups[] = [];
  selectedStudents: string[] = [];
  communicationsPostTypes = CommunicationsPostTypes;
  isLoading: boolean = false;
  constructor(private modalRef: BsModalRef, private userService: UserService, private socialLearningService: SocialLearningService) {
    super();
  }

  ngOnInit() {
    this.editInit();
  }
  editInit(): void {
    if (this.post) {
      this.postComment = this.post.postText;
      this.attachments = this.post.postAttachments;
      if (this.post.postShared.length > 0) {
        this.post.postShared.map(item => {
          this.selectedStudents.push(item.studentId);
        });
        this.sharingMode = 1;
        this.getStudents();
      }
    }
  }
  getStudents(): void {
    this.isLoading = true;
    this.userService.getStudentsBySectionSubjectId(this.post.sectionSubjectId).subscribe(
      (data: UserBasicInformation[]) => {
        data.map(item =>
          this.students.push({
            studentId: item.id,
            studentName: item.fullName,
            studentNameEn: item.fullNameEn
          })
        );
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
      }
    );
  }
  sharingModeChanged(): void {
    if (this.sharingMode === 0) {
      this.selectedStudents = [];
      this.students = [];
    } else {
      this.getStudents();
    }
  }
  updateChecked(studentId: string, isChecked: boolean): void {
    if (isChecked) {
      this.selectedStudents.push(studentId);
    } else {
      const selectedStudentIndex: number = this.selectedStudents.findIndex(item => item === studentId);
      if (selectedStudentIndex !== -1) this.selectedStudents.splice(selectedStudentIndex, 1);
    }
  }
  openUploader(): void {
    this.isUploaderOpened = !this.isUploaderOpened;
  }
  openEmoji(): void {
    this.isOpenedEmoji = !this.isOpenedEmoji;
  }
  emojiSelection(emojiEvent: EmojiEvent): void {
    if (emojiEvent.emoji.unified !== '1F595-1F3FB') {
      if (this.postComment) this.postComment += ' ' + emojiEvent.emoji.native;
      else this.postComment = emojiEvent.emoji.native;
      this.isOpenedEmoji = false;
    }
  }
  updatePost(): void {
    if (this.files.findIndex(item => item.status === FileStatuses.uploading) !== -1) {
      this.showWarning('Common.UploadingFileInProgress');
      return;
    }
    if (this.files.findIndex(item => item.status === FileStatuses.failed) !== -1) {
      this.showError('Common.ThereIsAFileThatFailsToUpload');
      return;
    }
    if (this.files.findIndex(item => item.status === FileStatuses.failed) !== -1) {
      this.showWarning('Common.UploadingFileInProgress');
      return;
    }
    if (!this.postComment.match(/\S/gm)) {
      this.showError('Common.PostMustIncludeAtLeastOneCharacter');
      return;
    }
    const attachmentIds: number[] = [];
    this.files.map(item => attachmentIds.push(item.result.attachmentId));
    const socialLearningPost: SocialLearningPost = {
      postId: this.post.postId,
      postItemText: this.postComment,
      postTypeId: this.post.postTypeId,
      sectionSubjectId: this.post.sectionSubjectId,
      attachmentIds: attachmentIds
    };
    if (this.sharingMode === 1) {
      socialLearningPost.studentIds = [];
      this.selectedStudents.map(item => {
        socialLearningPost.studentIds.push(item);
      });
    }
    this.isLoading = true;
    this.socialLearningService.UpdatePost(socialLearningPost).subscribe(
      (data: PostGetResult) => {
        data.postFiles = [];
        data.postImages = [];
        data.postAttachments.map(subItem => {
          if (subItem.attachmentMimeType && subItem.attachmentMimeType.includes('image')) data.postImages.push(subItem);
          else data.postFiles.push(subItem);
        });
        this.showSuccess('Common.PostUpdatedSuccessfully');
        this.saving.emit(data);
        this.modalClose();
        this.isLoading = false;
      },
      () => {
        this.showError('Common.ErrorWhileUpdatingPost');
        this.isLoading = false;
      }
    );
  }
  modalClose() {
    this.modalRef.hide();
  }
  getCheckedStudents(studentId: string): boolean {
    return this.selectedStudents.findIndex(item => item === studentId) !== -1;
  }
}
